import { render } from "./LinkedPropertiesTab.vue?vue&type=template&id=4117b266&scoped=true"
import script from "./LinkedPropertiesTab.vue?vue&type=script&lang=js"
export * from "./LinkedPropertiesTab.vue?vue&type=script&lang=js"

import "./LinkedPropertiesTab.vue?vue&type=style&index=0&id=4117b266&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4117b266"]])

export default __exports__